export function formatDate(dateString) {
  // if datestring is in the format dd/mm/yyyy return datestring
  if (dateString.includes("/")) return dateString;

  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;
}

export const parseAmount = (amount, notation = "standard", fractionDigits) => {
  if (!amount || amount === "" || amount === "0") return "₹0";
  const amountToFormat = amount
    .toString()
    .replace(/₹/g, "")
    .replace(/\.00|,/g, "");

  if (isNaN(Number(amountToFormat)) || Number(amountToFormat) < 1000) return `₹${amountToFormat}`;

  const formattedAmount = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: fractionDigits || 0,
    notation: notation ?? "standard",
  }).format(amountToFormat);

  return formattedAmount;
};
